export default "__VITE_ASSET__BzMc3H15__"